module.exports = __webpack_public_path__ + "static/img/fg-02_55.cdbbc9a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/fg-02_55.gif
// module id = AE6s
// module chunks = 1